// extracted by mini-css-extract-plugin
export var downArrow = "_87-0";
export var label = "_87-1";
export var treatmentCard = "_87-3";
export var upArrow = "_87-2";